export const OPTIMAL_CARE_ID = "1245";

export const BELLY_HEALTH_PRACTICE_ID = "2102";

export const ETHIZO_PRACTICE_ID = "111";

export const Community_Physician_ID = "117"

export const PEDIATRIC_ASSOCIATES_ID = "462";

export const SOUTHSIDE_MEDICAL_CENTER_ID = "165";

export const FOUR_CORNERS_PRIMARY_CARE_CENTERS_ID = "387";

export const EVERGREEN_PEDIATRICS_PLLC_ID = "233";

export const Juniper_Healthcare  = '1236';

export const BEHAVIORAL_CARE_SOLUTIONS_ID = "1104";

export const IMPACT_HEALTH_PC = "1218";

export const IMPACT_ID = "1218";

export const SUMMIT_MEDICAL_CONSULTANTS_ID = "204";

export const MID_ATLANTIC="1232"

export const ABODE_CARE_PARTNERS = "1237"

export const GREAT_CARE_AND_WELLNESS = "4131"

export const HDC_PRACTICE_ID = "1190"

export const MERIDIAN_HEALTH_PARTNERS_PRACTICE_ID = "1262"

export const TRUMEN_PRACTICE_ID = "1036"

export const MEDCAP_PRACTICE_ID = "1247"

export const VESPER_MEDICAL_CARE_PRACTICE_ID = "1241"